import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { mapStepLastWord } from '../mappers/step-last-word.mapper.ts';
import { StoryWordIndex } from '../slices/story-reading/story-reading.slice.types.ts';

import { selectCurrentLessonTaskStepKey } from './current-lesson-task-step-key.selector.ts';
import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectStepLastWord = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  selectCurrentLessonTaskStepKey,
  ({ task }, { step }): StoryWordIndex | undefined => {
    if (!task || step === undefined) return undefined;

    const lastWord = mapStepLastWord({
      task,
      step,
    });

    return lastWord ?? undefined;
  }
);
